<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  import detalheRateioServico from '~modulos/detalhe-rateio/servico';
  import tiposQuadro from '~js/tipos-quadro';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        contas: [],
        detalheRateios: [],
        tiposQuadro: tiposQuadro,
        metaEtapas: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone);
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolReembolso")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contas(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeDetalheRateio() {
        detalheRateioServico
          .lista()
          .then(detalheRateios => {
            this.detalheRateios = detalheRateios;
          });
      },
      listaDeMetaEtapas(idProjeto) {
        projetoServico
          .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function(e) {
            _this.$set(_this.solicitacao, 'idProjeto', this.value);

            _this.setarProjeto(this.value);


            if (!this.value) return;

            _this.$set(_this.solicitacao, 'idConta', '');
            _this.$set(_this.solicitacao, 'idProjetoMetaEtapa', '');
            
            if (_this.configuracao.selecaoDeContaWeb) {
              _this.listaContas(this.value);
            }
            
            if (_this.solicitacao.projeto.utilizarMetaEtapaProjeto) {
              _this.listaDeMetaEtapas(this.value);
            }
            
            _this.$emit('projetoAlterado', this.value);
          });
      },
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
    },
    computed: {
      validarConta() {
        return this.configuracao.selecaoDeContaWeb ? 'required' : '';
      },
      validarDetalheRateio() {
        return this.configuracao.utilizarDetalheRateioSolicitacao ? 'required' : '';
      },
      validarDataNascimento() {
        return this.configuracao.permitirCadPFSemDataNascimento ? 'date_format:DD/MM/YYYY' : 'required|date_format:DD/MM/YYYY'
      }
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');

      this.listaDeProjetos();
      this.iniciarSelect2Projeto();

      if (this.configuracao.utilizarDetalheRateioSolicitacao) {
        this.listaDeDetalheRateio();
      }
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select
            id="projeto"
            class="form-control"
            v-model="solicitacao.idProjeto"
            data-vv-name="projeto"
            v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoReembolso) || projeto.acompanhamentoPendente || projeto.inativoDebito">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoReembolso)">
                (Data limite até: {{ projeto.dataLimiteSolicitacaoReembolso | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolicitacaoReembolso) && !projeto.inativoDebito">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>

              <template v-if="projeto.inativoDebito">
                (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input
            type="text"
            class="form-control"
            v-model="solicitacao.projeto.nomeProjeto"
            disabled>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarDetalheRateio, {'has-error': errors.has('detalheRateio')}]">
          <label class="control-label" for="detalhe">Detalhe</label>

          <select
            id="detalhe"
            class="form-control"
            v-model="solicitacao.idDetalheRateio"
            data-vv-name="detalheRateio"
            data-vv-as="detalhe"
            v-validate="validarDetalheRateio">
            <option value="">Selecione...</option>
            <option :value="detalheRateio.id" v-for="detalheRateio in detalheRateios">{{ detalheRateio.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('detalheRateio')">{{ errors.first('detalheRateio') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="configuracao.selecaoDeContaWeb">
      <div class="col-xs-12">
        <div class="form-group" :class="[validarConta, {'has-error': errors.has('conta')}]">
          <label class="control-label" for="id-conta">Conta</label>

          <select
            id="id-conta"
            class="form-control"
            v-model="solicitacao.idConta"
            data-vv-name="conta"
            v-validate="validarConta">
            <option value="">{{ contas.length > 0 ? 'Selecione...' : 'Selecione o projeto' }}</option>
            <option :value="conta.id" v-for="conta in contas">{{ conta.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="solicitacao.projeto.utilizarMetaEtapaProjeto">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
          <label class="control-label" for="meta-etapa">Meta etapa</label>

          <select
            class="form-control"
            id="meta-etapa"
            v-model="solicitacao.idProjetoMetaEtapa"
            data-vv-name="metaEtapa"
            data-vv-as="meta etapa"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option
              :value="metaEtapa.idProjetoMetaEtapa"
              v-for="(metaEtapa, index) in metaEtapas">
              {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">
    
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nomeTerceiro')}">
          <label class="control-label" for="nome-terceiro">Nome do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="nome-terceiro"
              v-model="solicitacao.nomeTerceiro"
              data-vv-name="nomeTerceiro"
              data-vv-as="Nome do beneficiário"
              v-validate="'required'"
              maxlength="100"
              :disabled="desabilitarBeneficiario">

          <p class="text-danger" v-show="errors.has('nomeTerceiro')">{{ errors.first('nomeTerceiro') }}</p>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento-terceiro">Email do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="documento-terceiro"
              v-model="solicitacao.documentoTerceiro"
              disabled>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
          <label class="control-label" for="nascimento">Data de nascimento</label>

          <input
              id="nascimento"
              class="form-control"
              type="text"
              v-model="solicitacao.dataNascimento"
              v-mascara="'data'"
              placeholder="    /    /"
              data-vv-name="dataNascimento"
              data-vv-as="data de nascimento"
              v-validate="validarDataNascimento">

          <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <label class="control-label" for="identidade">Identidade</label>

          <input
              id="identidade"
              class="form-control"
              type="text"
              v-model="solicitacao.identidade"
              maxlength="20">
        </div>
      </div>
    </div>
      
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">Endereço</label>

          <input
              id="endereco"
              class="form-control"
              type="text"
              v-model="solicitacao.endereco"
              data-vv-name="endereco"
              data-vv-as="endereço"
              v-validate="'required'"
              maxlength="60">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">Número</label>

          <input
              id="numero"
              class="form-control"
              type="text"
              v-model="solicitacao.numero"
              data-vv-name="numero"
              data-vv-as="número"
              v-validate="'required'"
              maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input
            id="complemento"
            class="form-control"
            type="text"
            v-model="solicitacao.complemento"
            maxlength="30">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="solicitacao.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="solicitacao.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('pais')}" id="pais">
          <label class="control-label" for="pais">País</label>

          <input id="pais"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.pais"
                 data-vv-as="país"
                 data-vv-name="pais"
                 v-validate="'required'"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('pais')">{{ errors.first('pais') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneResidencial')}">
          <label class="control-label" for="telefone-residencial">Tel. residencial</label>

          <input
              type="text"
              class="form-control"
              id="telefone-residencial"
              maxlength="20"
              v-model="solicitacao.telefoneResidencial"
              data-vv-as="tel. residencial"
              data-vv-name="telefoneResidencial"
              v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefoneResidencial')">{{ errors.first('telefoneResidencial') }}</p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label" for="telefone-comercial">Tel. comercial</label>

          <input
              id="telefone-comercial"
              class="form-control"
              type="text"
              maxlength="20"
              v-model="solicitacao.telefoneComercial">
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label" for="fax">Fax</label>

          <input
              id="fax"
              class="form-control"
              type="text"
              maxlength="20"
              v-model="solicitacao.fax">
        </div>
      </div>
    </div>

    <p><b>Informe os dados da pessoa que devemos contatar, caso haja dúvidas ao
      processarmos essa solicitação, ou marque o campo abaixo.</b></p>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-estrangeiro/componentes/compartilhado/FormDadosCadastrais.vue